module.exports = __webpack_public_path__ + "static/media/partner-bpi-deeptech.712da4a9.png";